import React from 'react'
import ImageWrapper from '../common/ImageWrapper'
import PlayStoreButton from '../common/PlayStoreButton'
import AppleStoreButton from '../common/AppleStoreButton'
import { graphql, useStaticQuery } from 'gatsby'

const AceYourIelts = () => {

    const data = useStaticQuery(query);

    const { allStrapiHomeAceYourIeltsExam: { nodes: HomeAceYourIeltsExam } } = data;

    const { home_aceYourIeltsExam_heading, home_aceYourIeltsExam_subheading, home_aceYourIeltsExam_image, home_aceYourIeltsExam_list } = HomeAceYourIeltsExam[0];

    return (
        <>
            <section className="ace_your_ielts_main">
                <div className="ace_your_ielts_left">
                    <h2>{home_aceYourIeltsExam_heading}</h2>
                    <p>{home_aceYourIeltsExam_subheading}</p>
                    <div className="ace_your_ielts_left_mobile_image">
                        <ImageWrapper ImgUrl={home_aceYourIeltsExam_image.image.url}/>
                    </div>
                    <ul className="ace_your_ielts_list">
                        {home_aceYourIeltsExam_list.map((listItem) => (
                            <li key={listItem.id}>{listItem.list_item_heading}</li>  
                        ))}
                    </ul>
                    <div className="ace_your_ielts_btn_wrapper">
                        <PlayStoreButton MaxWidth={285}/>
                        <AppleStoreButton MaxWidth={285}/>
                    </div>
                </div>
                <div className="ace_your_ielts_right">
                    <ImageWrapper ImgUrl={home_aceYourIeltsExam_image.image.url}/>
                </div>
            </section>
        </>
    )
}

export const query = graphql`
{
    allStrapiHomeAceYourIeltsExam {
    nodes {
      home_aceYourIeltsExam_heading
      home_aceYourIeltsExam_subheading
      home_aceYourIeltsExam_image {
        image {
          url
        }
      }
      home_aceYourIeltsExam_list {
        id
        list_item_heading
      }
    }
  }
}
`

export default AceYourIelts